'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _StepBase = require('../StepBase');

var _StepBase2 = _interopRequireDefault(_StepBase);

var _MessageWarning = require('../MessageWarning');

var _MessageWarning2 = _interopRequireDefault(_MessageWarning);

var _CartDetailItem = require('./CartDetailItem');

var _CartDetailItem2 = _interopRequireDefault(_CartDetailItem);

var _CatalogTotalRow = require('./CatalogTotalRow');

var _CatalogTotalRow2 = _interopRequireDefault(_CatalogTotalRow);

var _DiscountCoupon = require('./DiscountCoupon');

var _DiscountCoupon2 = _interopRequireDefault(_DiscountCoupon);

var _Voucher = require('./Voucher');

var _Voucher2 = _interopRequireDefault(_Voucher);

var _DiscountCouponForm = require('./DiscountCouponForm');

var _DiscountCouponForm2 = _interopRequireDefault(_DiscountCouponForm);

var _DispatchWarning = require('../DispatchWarning');

var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _GiftItem = require('../GiftItem');

var _GiftItem2 = _interopRequireDefault(_GiftItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
    return {
        cart: state.cart,
        loyaltyProgramPointsAvailable: state.cart.loyaltyProgramPointsAvailable,
        loyaltyProgramAvailable: state.cart.loyaltyProgramAvailable,
        items: state.cart.items,
        catalogs: state.cart.catalogs,
        giftItems: state.cart.giftItems || [],
        totalPrice: state.cart.totalPrice || {},
        coupon: state.cart.coupon,
        voucher: state.cart.voucher,
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon)
    };
}

var mapDispatchToProps = {
    saveOptions: _actions2.default.saveOptions,
    setStep: _actions2.default.setStep,
    updateFreeProducts: _actions2.default.updateFreeProducts,
    getLoyaltyProgramAvailable: _actions2.default.getLoyaltyProgramAvailable
};

var CartDetailStep = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
    (0, _inherits3.default)(CartDetailStep, _CartDetailStepBase);
    (0, _createClass3.default)(CartDetailStep, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                _this2.props.getLoyaltyProgramAvailable();
            }, 500);
        }
    }]);

    function CartDetailStep(props) {
        (0, _classCallCheck3.default)(this, CartDetailStep);
        return (0, _possibleConstructorReturn3.default)(this, (CartDetailStep.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep)).call(this, props, 1));
    }

    (0, _createClass3.default)(CartDetailStep, [{
        key: 'nextStep',
        value: function nextStep() {
            var _this3 = this;

            if (this.props.processing) return;
            setTimeout(function () {
                var _props = _this3.props,
                    voucher = _props.voucher,
                    processing = _props.processing;

                if (processing) return;
                var voucherRemainingPrice = voucher ? voucher.info.nominalValue - voucher.info.appliedValue : 0;
                var alerts = [];
                var alertHandler = function alertHandler(stay) {
                    if (!stay) {
                        if (alerts.length > 0) {
                            setTimeout(alerts.pop(), 50);
                        } else {
                            (0, _get3.default)(CartDetailStep.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep.prototype), 'nextStep', _this3).call(_this3);
                        }
                    }
                };
                if (voucherRemainingPrice > 0) {
                    alerts.push(function () {
                        return sweetAlert({
                            text: Resx.App.RemainingVoucherValueWarning.replace("{0}", (0, _linksoftAlbatros.formatPrice)(voucherRemainingPrice, _linksoftAlbatros.PriceType.CartTotalPrice)),
                            type: 'warning',
                            title: Resx.App.RemainingVoucherValueWarningTitle,
                            showCancelButton: true,
                            cancelButtonText: Resx.App.ContinueAnyway,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: Resx.App.BackToCart
                        }, alertHandler);
                    });
                }
                if (alerts.length > 0) {
                    setTimeout(alerts.pop(), 50);
                } else {
                    (0, _get3.default)(CartDetailStep.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep.prototype), 'nextStep', _this3).call(_this3);
                }
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                items = _props2.items,
                giftItems = _props2.giftItems,
                totalPrice = _props2.totalPrice,
                coupon = _props2.coupon,
                voucher = _props2.voucher,
                processing = _props2.processing,
                catalogs = _props2.catalogs,
                loyaltyProgramPointsAvailable = _props2.loyaltyProgramPointsAvailable,
                loyaltyProgramAvailable = _props2.loyaltyProgramAvailable,
                cart = _props2.cart;

            var showSubmitButton = items.length > 0 || giftItems.length > 0;
            var freeDeliveryMessage = this.freeDelivery();
            var possibleFreeDeliveryMessage = this.possibleFreeDelivery();
            var freeProductMessage = this.freeProducts();

            var ultraTotalPrice = Math.max(totalPrice.finalPrice - (voucher ? voucher.info.appliedValue : 0), 0);
            var discount = totalPrice.standardPrice - totalPrice.finalPrice;

            var nextStepClass = 'btn btn--lg btn--green';
            if (processing) nextStepClass += ' btn--inactive';

            return _react2.default.createElement(
                'div',
                { className: this.stepClass() },
                _react2.default.createElement(
                    'div',
                    { className: 'cart__row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__wrap' },
                        _react2.default.createElement(
                            'h1',
                            { className: 'mt-0' },
                            Resx.App.SelectedProducts
                        ),
                        _react2.default.createElement(
                            'table',
                            { className: 'cart__table' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        Resx.App.ProductName
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { className: 'text-center' },
                                        Resx.Common.Type
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { className: 'text-center' },
                                        Resx.Common.Amount
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { className: 'text-right' },
                                        Resx.Common.PriceClub
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        { className: 'text-right' },
                                        Resx.Common.Total
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            ),
                            _react2.default.createElement(
                                'tbody',
                                null,
                                giftItems.length > 0 && [_react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'td',
                                        { colSpan: '6' },
                                        _react2.default.createElement(
                                            'h2',
                                            { className: 'cart-items__title' },
                                            Resx.App.Gifts
                                        )
                                    )
                                ), giftItems.map(function (item) {
                                    return _react2.default.createElement(_GiftItem2.default, (0, _extends3.default)({}, item, { key: item.giftId }));
                                })],
                                !catalogs ? null : catalogs.filter(function (c) {
                                    return c.items.length > 0;
                                }).map(function (c) {
                                    return [_react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: '6' },
                                            _react2.default.createElement(
                                                'h2',
                                                null,
                                                c.name
                                            )
                                        )
                                    ), c.items.sort(function (a, b) {
                                        return a.name.localeCompare(b.name);
                                    }).map(function (item) {
                                        return _react2.default.createElement(_CartDetailItem2.default, (0, _extends3.default)({}, item, { key: item.id }));
                                    }), _react2.default.createElement(_CatalogTotalRow2.default, { catalog: c, key: c.id, includeWoVatPrice: false })];
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'aside',
                        { className: 'cart__aside' },
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-summary' },
                            _react2.default.createElement(
                                'h3',
                                { className: 'h5' },
                                Resx.Common.Summary
                            ),
                            _react2.default.createElement(
                                'table',
                                { className: 'cart-summary__table' },
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-right' },
                                            Resx.App.ItemsInCart
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-right red' },
                                            items.reduce(function (a, item) {
                                                return a + item.amount;
                                            }, 0),
                                            ' ',
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                Resx.App.Pcs
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-right' },
                                            Resx.Common.Total
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'text-right td__price' },
                                            (0, _linksoftAlbatros.formatPrice)(totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                        )
                                    )
                                )
                            ),
                            cart.isLibrary && _react2.default.createElement(
                                'div',
                                { className: 'text-right ex-lh' },
                                _react2.default.createElement('hr', { className: 'hr--dark' }),
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    Resx.Common.YourTotalDiscountIs
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'strong',
                                    { className: 'red mt-2 d-inline-block nowrap' },
                                    (0, _linksoftAlbatros.formatPrice)(discount, _linksoftAlbatros.PriceType.CartTotalPrice)
                                ),
                                _react2.default.createElement('hr', { className: 'hr--dark' })
                            ),
                            cart.isConfidant && _react2.default.createElement(
                                'div',
                                { className: 'text-right ex-lh' },
                                _react2.default.createElement('hr', { className: 'hr--dark' }),
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    Resx.Common.YourTotalCommissionIs
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'strong',
                                    { className: 'red mt-2 d-inline-block nowrap' },
                                    (0, _linksoftAlbatros.formatPrice)(cart.totalConfidantCommission, _linksoftAlbatros.PriceType.CartTotalPrice)
                                ),
                                _react2.default.createElement('hr', { className: 'hr--dark' })
                            ),
                            !!freeDeliveryMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--van', text: freeDeliveryMessage.text }),
                            !!possibleFreeDeliveryMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--van', text: possibleFreeDeliveryMessage.text }),
                            !!freeProductMessage.text && _react2.default.createElement(_MessageWarning2.default, { icon: 'icon--gift', text: freeProductMessage.text }),
                            _react2.default.createElement(_DispatchWarning2.default, null),
                            _react2.default.createElement(_DiscountCouponForm2.default, coupon),
                            _react2.default.createElement(_DiscountCoupon2.default, coupon),
                            _react2.default.createElement(_Voucher2.default, voucher),
                            loyaltyProgramAvailable && loyaltyProgramPointsAvailable > 0 && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement('hr', { className: 'hr--dark' }),
                                _react2.default.createElement(
                                    'h3',
                                    { className: 'h4 mt-0' },
                                    Resx.App.LoyaltyCurrentPointsLong,
                                    ':'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'flex justify-content-between' },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'strong',
                                            { className: 'title' },
                                            (0, _linksoftAlbatros.format)(loyaltyProgramPointsAvailable, 'N0')
                                        ),
                                        ' ',
                                        Resx.Common.Points
                                    ),
                                    _react2.default.createElement(
                                        'a',
                                        { className: 'btn btn--sm btn--green', href: '/Gift/Index' },
                                        Resx.Common.Choose
                                    )
                                )
                            ),
                            showSubmitButton && _react2.default.createElement(
                                'div',
                                { className: 'text-center' },
                                _react2.default.createElement('hr', { className: 'hr--dark', style: { marginTop: 15, marginBottom: 15 } }),
                                _react2.default.createElement(
                                    'button',
                                    { className: nextStepClass, onClick: function onClick() {
                                            return _this4.nextStep();
                                        } },
                                    Resx.App.NextStep,
                                    _react2.default.createElement('i', { className: 'icon--arrow-right icon--arrow-right--after' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'text-center mt-5' },
                            _react2.default.createElement(
                                'a',
                                { href: '/', className: 'btn btn--sm btn--narrow' },
                                _react2.default.createElement('i', { className: 'icon--arrow-left ' }),
                                ' ',
                                Resx.App.BackToShopping
                            )
                        )
                    )
                )
            );
        }
    }]);
    return CartDetailStep;
}(_StepBase2.default), _class2.propTypes = {
    loyaltyProgramPointsAvailable: _propTypes2.default.number.isRequired,
    items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    catalogs: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    giftItems: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    totalPrice: _propTypes2.default.object.isRequired,
    coupon: _propTypes2.default.object,
    voucher: _propTypes2.default.object,
    processing: _propTypes2.default.bool,

    loyaltyProgramAvailable: _propTypes2.default.bool.isRequired,
    empty: _propTypes2.default.func.isRequired,
    setStep: _propTypes2.default.func.isRequired,
    updateFreeProducts: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = CartDetailStep;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/Step.js
// module id = 1131
// module chunks = 0